import IndirizzoEntity from '@/pages/anagrafica/generale/IndirizzoEntity';
import AssociazioneEntity from '@/pages/anagrafica/associazioni/AssociazioneEntity';
import TipologiaEntity from '@/pages/generale/TipologiaEntity';

export default function (evento) {
  this.id = evento ? evento.id : null;
  this.Associazione = evento ? new AssociazioneEntity(evento.Associazione) : new AssociazioneEntity();
  this.isAttivo = evento ? evento.isAttivo : false;
  this.isOpen = evento ? evento.isOpen : false;
  this.isIndoor = evento ? evento.isIndoor : false;
  this.ClassificazioneEvento = evento ? evento.ClassificazioneEvento : null;
  this.TipologiaEvento = evento ? evento.TipologiaEvento : null;
  this.CoordinateGPS = evento ? evento.CoordinateGPS : null;
  this.TitoloEvento = evento ? evento.TitoloEvento : null;
  this.AnnoSportivoId = evento ? evento.AnnoSportivo.id : null;
  this.AnnoSportivo = evento ? new TipologiaEntity(evento.AnnoSportivo) : new TipologiaEntity();
  this.DataApertura = evento ? evento.DataApertura : null;
  this.DataChiusura = evento ? evento.DataChiusura : null;
  this.DataInvioScore = evento ? evento.DataInvioScore : null;
  this.InvioScore = evento ? evento.InvioScore : false;
  this.DataEvento = evento ? evento.DataEvento : null;
  this.DescrizioneEvento = evento ? evento.DescrizioneEvento : null;
  this.EmailRiferimento = evento ? evento.EmailRiferimento : null;
  this.Telefono = evento ? evento.Telefono : null;
  this.Cellulare = evento ? evento.Cellulare : null;
  this.IndirizzoEvento = evento ? new IndirizzoEntity(evento.IndirizzoEvento) : new IndirizzoEntity();
  this.ClasseCredito = evento ? evento.ClasseCredito : null;
  this.Giudice = evento ? evento.Giudice : null;
  this.Istruttore = evento ? evento.Istruttore : null;
  this.StatoEvento = evento ? evento.StatoEvento : 'Inserito';
  this.NumeroPostiTotali = evento ? evento.NumeroPostiTotali : 0;
  this.NumeroPostiRiservati = evento ? evento.NumeroPostiRiservati : 0;
  this.TipoEvento = evento ? new TipologiaEntity(evento.TipoEvento) : new TipologiaEntity();
  this.TipoIscrittiAbilitati = evento ? evento.TipoIscrittiAbilitati : 'Iscritti';
  this.TipoIscrizione = evento ? evento.TipoIscrizione : 'Societa';
  this.abilitatoPrenotazione = evento ? evento.abilitatoPrenotazione : false;
  this.abilitatoIscrizione = evento ? evento.abilitatoIscrizione : false;
  this.eventoConi = evento ? evento.eventoConi : null;
  this.MaxPettorale = evento ? evento.MaxPettorale : null;
}
